import React from 'react';
import { Button } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import toast from "react-hot-toast";
import { useTranslation } from 'react-i18next';
import { logEvent } from '../../analytics';
import { marked } from 'marked';

function CopyToClipboardButton({ textToCopy, disabled }) {
  const { t } = useTranslation();

  const handleCopy = async () => {
    logEvent('Note', 'Copy');

    try {
      // Convert Markdown to HTML
      const htmlBody = marked.parse(textToCopy);
      const styledHtml = `
        <div style="font-size:14px; font-family:Arial,sans-serif; line-height:1.5;">
          ${htmlBody}
        </div>
      `;
      console.log('[CopyToClipboardButton] HTML:', styledHtml);

      // Write both plain text and rich HTML to the clipboard
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/plain': new Blob([textToCopy], { type: 'text/plain' }),
          'text/html': new Blob([styledHtml], { type: 'text/html' }),
        }),
      ]);

      toast.success(t('session_details.copy.success'));
    } catch (error) {
      console.error('Copy failed', error);
      toast.error(t('session_details.copy.error'));
    }
  };

  return (
    <div>
      <Button
        icon={<CopyOutlined />}
        disabled={disabled}
        onClick={handleCopy}
        data-testid='copy-button'
      >
        {t('session_details.copy.label')}
      </Button>
    </div>
  );
}

export default CopyToClipboardButton;